import { enumType } from '@shared/core/types/common';

enum SEARCH_MODE {
    LOCATION_ADDRESS = OLO.Enums.SEARCH_MODE.LOCATION_ADDRESS,
    DELIVERY_ADDRESS = OLO.Enums.SEARCH_MODE.DELIVERY_ADDRESS,
}

export const searchModeEnum = enumType('SEARCH_MODE', SEARCH_MODE);
